import { getCookie, setCookie } from "./util/cookie.js";
import { isUuid, randomUUID } from "./util/uuid.js";
import type { SessionIds } from "./types.js";

const VISITOR_COOKIE = "_ivis";
const SESSION_COOKIE = "_isess";
const VISITOR_TTL_SECONDS = 365 * 24 * 60 * 60;
const SESSION_TTL_SECONDS = 30 * 60;

export function ensureSession(): SessionIds {
  const existingVisitor = getCookie(VISITOR_COOKIE);
  const visitorId: string = isUuid(existingVisitor)
    ? (existingVisitor as string)
    : randomUUID();
  if (!isUuid(existingVisitor)) {
    setCookie(VISITOR_COOKIE, visitorId, VISITOR_TTL_SECONDS);
  }

  const existingSession = getCookie(SESSION_COOKIE);
  const sessionId: string = isUuid(existingSession)
    ? (existingSession as string)
    : randomUUID();
  // Always slide on init.
  setCookie(SESSION_COOKIE, sessionId, SESSION_TTL_SECONDS);

  return {
    sessionId,
    visitorId,
    touch(): void {
      setCookie(SESSION_COOKIE, sessionId, SESSION_TTL_SECONDS);
    },
  };
}
